<script>
  import {onMount} from 'svelte';
  import {url} from '@sveltech/routify';

  import ParrillaDeSedes from "../../Components/Sedes/Parrilla/index.svelte";

  import Loading from "../../Components/UI/Loading.svelte";
  import Error from "../../Components/UI/Error.svelte";
  import Boton from "../../Components/UI/Boton.svelte";
  import Titulo from "../../Components/UI/Titulo.svelte";
  import Modal from "../../Components/UI/Modal.svelte";
  import Icono from "../../Components/UI/Icono.svelte";

  import sedes from '../../Stores/sedes-store';
  import storeGrupos from '../../Stores/grupos-store';

  import Caja from "../../Components/UI/Caja.svelte";
  import CampoDeTexto from "../../Components/UI/CampoDeTexto.svelte";
  import Subtitulo from "../../Components/UI/Subtitulo.svelte";
  import {creaOpciones} from "../../Utils/selects";

  onMount(() => {
    storeGrupos.cargar();
    sedes.cargar();
  });

  let grupos, opcionesDeGrupo, sedeEliminada, filtradosPorTexto, listadoFiltrado, errorEliminacion;
  $: grupos = $storeGrupos.listado;
  $: errorEliminacion = $storeGrupos.errorEliminacion;
  $: opcionesDeGrupo = creaOpciones(grupos);

  let filtro = {
    texto: '',
    grupo: ''
  };

  const actualizaFiltro = campo => ({target}) => {
    filtro = {
      ...filtro,
      [campo]: target.value
    }
  };

  $: error = $sedes.error;
  $: sedeEliminada = $sedes.sedeEliminando;
  $: filtradosPorTexto = $sedes.listado.filter(x => {
    return filtro.texto === '' || x.nombre.toLowerCase().indexOf(filtro.texto.toLowerCase()) >= 0;
  });
  $: listadoFiltrado = filtradosPorTexto.filter(x => {
    return filtro.grupo === '' || (x.grupo && x.grupo.id === +filtro.grupo);
  });

  const eliminarSede = e => sedes.eliminarSede(e.detail);
  const eliminaSedeDeVerdad = () => sedes.eliminaSedeDeVerdad(sedeEliminada);
</script>

<style>
    .nueva-sede {
        margin: var(--padding-global) 0;
        text-align: right;
    }

    .filtro {
        margin-bottom: var(--padding-global);
    }

    .filtro-contenido {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        grid-gap: var(--padding-global);
    }
</style>

<svelte:head>
    <title>Sedes</title>
</svelte:head>

<Titulo>Sedes</Titulo>

{#if error}
    <Error on:cancel={() => error = false}>{$sedes.error}</Error>
{/if}

<div class="contenido">
    {#if $sedes.cargando }
        <Caja cabecera={false}>
            <Loading/>
        </Caja>
    {:else if $sedes.listado }
        <div class="filtro">
            <Caja>
                <div slot="titulo">
                    <Subtitulo>Filtro</Subtitulo>
                </div>

                <div class="filtro-contenido">
                    <CampoDeTexto icono="search" label="Nombre"
                                  value={filtro.texto} on:input={actualizaFiltro('texto')}/>
                </div>
            </Caja>
        </div>

        <div class="nueva-sede">
            <Boton href="{$url('../nueva')}">Nueva sede</Boton>
        </div>

        <ParrillaDeSedes on:eliminar-sede={eliminarSede}
                         sedes={listadoFiltrado}/>

        {#if listadoFiltrado.length > 6}
            <div class="nueva-sede">
                <Boton href="{$url('../nueva')}">Nueva sede</Boton>
            </div>
        {/if}
    {/if}
</div>

{#if sedeEliminada}
    <Modal title="¿Está seguro de que desea eliminar la sede {sedeEliminada.nombre}?"
           error={errorEliminacion}>
        <div slot="footer" class="opciones">
            <Boton on:click={eliminaSedeDeVerdad} tipo="peligro">
                <Icono>check</Icono>
                Confirmar
            </Boton>
            <Boton on:click={() => sedeEliminada = false} tipo="neutral">
                <Icono>cancel</Icono>
                Cancelar
            </Boton>
        </div>
    </Modal>
{/if}